import { render, staticRenderFns } from "./DetailsTwo.vue?vue&type=template&id=33df7b04&scoped=true&"
import script from "./DetailsTwo.vue?vue&type=script&lang=js&"
export * from "./DetailsTwo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTwo.vue?vue&type=style&index=0&id=33df7b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df7b04",
  null
  
)

export default component.exports